import * as React from 'react';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import './index.css';
import ClientsPage, { loader as clientsLoader } from './routes/clients';
import PatientsPage, { loader as patientsLoader } from './routes/patients';
import PatientsClustersPage, { loader as patientsClustersLoader } from './routes/patientClusters';

import EnterCodeFragment from './components/auth/EnterCodeFragment';
import RequestCodeFragment from './components/auth/RequestCodeFragment';
import LoginPage from './routes/login';

import App from './App';
import ErrorPage from './components/ErrorPage';
import WrongRoleFragment from './components/auth/WrongRole';
import PatientsLivePage, { loader as patientsLiveLoader } from './routes/patientLive';

import EmbededPage, { loader as embededLoader } from './routes/embeded'
import ErrorNoticePage, { loader as errorNoticeLoader } from './routes/errorNotice';
import ReferalsPage, { loader as referalLoader } from './routes/referals/referalPage';
import AppPublic from './AppPublic';

const router = createBrowserRouter([
    {
        path: '/notice',
        element: <ErrorNoticePage />,
        loader:errorNoticeLoader,
        children: []
    },
    {
        path: '/auth',
        element: <LoginPage />,
        children: [
            {
                path: 'login',
                element: <RequestCodeFragment />
            },
            {
                path: 'code',
                element: <EnterCodeFragment />
            },
            {
                path: 'error',
                element: <WrongRoleFragment />
            }
        ]
    },
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Navigate to='clients' />
            },
            {
                path: 'embeded',
                loader: embededLoader,
                element: <EmbededPage/ >
            },
            {
                path: 'admin',
                lazy: async () => {
                    const module = await import('./routes/admin');
                    return {loader:module.loader, Component:module.default}
                },
                errorElement:<div>Failed to Load Admin Page</div>
            },
            {
                path: 'clients',
                element: <ClientsPage />,
                loader: clientsLoader,
                children: [
                    {
                        path: ':clientId',
                        children: [
                            {
                                index: true,
                                element: <Navigate to='patients' />
                            },
                        ]
                    }
                ]
            },
            {
                path: 'clients/:clientId/patients',
                element: <PatientsPage />,
                loader: patientsLoader,
                children: []
            },
            {
                path: 'clients/:clientId/patientsClusters',
                lazy: async () => {
                    const module = await import('./routes/patientClusters');
                    return {loader:module.loader, Component:module.default}
                },
                errorElement:<div>Failed to Load Patient Clusters Page</div>
            },
            {
                path: 'clients/:clientId/patientsLive',
                element: <PatientsLivePage />,
                loader: patientsLiveLoader,
                children: []
            },
            {
                path: 'clients/:clientId/campaigns',
                lazy: async () => {
                    const module = await import('./routes/campaigns');
                    return {loader:module.loader, Component:module.default}
                },
                errorElement:<div>Failed to Load Campaigns Page</div>
            },
        ]
    },
    {
        path: "/p/",
        element: <AppPublic />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'referals/:clientId',
                loader: referalLoader,
                element: <ReferalsPage/>,
                children: []
            },
        ]
    },
    {
        path: '/tests/embeded',
        lazy: async () => {
            if(process.env.NODE_ENV !== 'production') {
                const module = await import('./routes/tests/testEmbeded');
                return {Component:module.default}
            }
            return {Component:ErrorPage}
        },
        errorElement:<div>Failed to Load Embeded Test Page</div>
    },
]);

const RoutesRoot = (): JSX.Element => {
    return <RouterProvider router={router}/>
}
export default RoutesRoot;